module.exports = __webpack_public_path__ + "static/media/team-icons-sprites.7f983485.svg";